/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Delegation,
    DelegationFromJSON,
    DelegationFromJSONTyped,
    DelegationToJSON,
    DelegationListAllOf,
    DelegationListAllOfFromJSON,
    DelegationListAllOfFromJSONTyped,
    DelegationListAllOfToJSON,
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
} from './';

/**
 * 
 * @export
 * @interface DelegationList
 */
export interface DelegationList {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof DelegationList
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof DelegationList
     */
    is_total_count_clipped: boolean;
    /**
     * 
     * @type {Array<Delegation>}
     * @memberof DelegationList
     */
    delegations: Array<Delegation>;
}

export function DelegationListFromJSON(json: any): DelegationList {
    return DelegationListFromJSONTyped(json, false);
}

export function DelegationListFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegationList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'delegations': ((json['delegations'] as Array<any>).map(DelegationFromJSON)),
    };
}

export function DelegationListToJSON(value?: DelegationList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'delegations': ((value.delegations as Array<any>).map(DelegationToJSON)),
    };
}


